export default __webpack_public_path__ + "static/WatchonYouTube-black-SVG-c0a778d9bc2f7d7ee9fe547f71a81156.svg";